import omit from "lodash/omit";
import { getCommonHeaderProps } from "PFApp/components/card_tx/card_tx.utils";
import { CardTxContentProps } from "PFApp/components/card_tx/card_tx_content";
import { PostContent } from "PFApp/components/card_tx/content/post_content";
import { PostHeader } from "PFApp/components/card_tx/header/post_header";
import { Status } from "PFApp/components/card_tx/status/status";

export type PostVariantProps = Pick<
  CardTxContentProps,
  | "task"
  | "type"
  | "isFeed"
  | "isDraft"
  | "handleShare"
  | "handleEditPost"
  | "handleHeaderClick"
  | "handleRefetchActivities"
>;

export const PostVariant = ({
  task,
  type,
  isFeed,
  isDraft,
  handleShare,
  handleEditPost,
  handleHeaderClick,
  handleRefetchActivities
}: PostVariantProps) => {
  const commonHeaderProps = getCommonHeaderProps({
    task,
    type,
    isFeed,
    handleShare,
    handleRefetchActivities
  });

  return (
    <>
      <PostHeader
        {...omit(commonHeaderProps, ["type"])}
        handleEditPost={handleEditPost}
        handleHeaderClick={handleHeaderClick}
      />
      <Status isPrivate={task.private} isDraft={isDraft} />
      <PostContent task={task} />
    </>
  );
};
